// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("app/css/" + chunkId + ".style.css");